export const mainGrowthAreaArray = [
  {
    value: 1,
    label: 'GROW IN THE WAY YOU THINK',
  },
  {
    value: 2,
    label: 'GROW IN THE WAY YOU TALK WITH OTHERS',
  },
  {
    value: 3,
    label: 'GROW IN THE WAY YOU TAKE ACTION',
  },
]

export const growthAreasObject = {
  // GROW IN THE WAY YOU THINK
  1: [
    { id: 101, label: 'All-or-Nothing Thinking → Flexible Thinking' },
    { id: 102, label: 'Discounting the Positive → Acknowledging the Positive' },
    { id: 103, label: 'Jumping to Conclusions → Considering Alternative Perspective' },
    { id: 104, label: 'Emotional Reasoning → Thoughtful Reasoning' },
    { id: 105, label: 'Overgeneralization → Specific Thinking' },
    { id: 106, label: 'Fixed Mindset → Growth Mindset' },
    { id: 107, label: 'Mental Filtering → Balanced View' },
    { id: 108, label: 'Should Statements → Goal-Oriented Statements' },
  ],
  // GROW IN THE WAY YOU TALK WITH OTHERS
  2: [
    { id: 201, label: 'Passive-Aggressive → Assertive' },
    { id: 202, label: 'Blaming → Taking Responsibility' },
    { id: 203, label: 'Criticism → Supportive Feedback' },
    { id: 204, label: 'Contempt → Respectful Disagreement' },
    { id: 205, label: 'Defensiveness → Receptive Listening' },
    { id: 206, label: 'Stonewalling → Engaged Communication' },
    { id: 207, label: 'Interrupting → Active Listening' },
    { id: 208, label: 'Mind Reading → Asking for Clarification' },
  ],
  // GROW IN THE WAY YOU TAKE ACTION
  3: [
    { id: 301, label: 'Reactive → Proactive' },
    { id: 302, label: 'Procrastination → Prioritization' },
    { id: 303, label: 'Avoidance → Confronting Challenges' },
    { id: 304, label: 'Perfectionism → Striving for Excellence' },
    { id: 305, label: 'People-Pleasing → Healthy Boundary Setting' },
    { id: 306, label: 'Self-Sabotage → Self-Care' },
    { id: 307, label: 'Overworking → Intentional Rest' },
    { id: 308, label: 'Addictive Behavior → Healthy Habits' },
  ],
}

export const engagementTypeArray = [
  {
    value: 1,
    label: 'Consume',
  },
  {
    value: 2,
    label: 'Create',
  },
  // {
  //   value: 3,
  //   label: 'Contribute',
  // },
  {
    value: 3, // ! Old already added "Contribute" value will be stored as "Contribute to self"
    label: 'Contribute to self',
  },
  {
    value: 6,
    label: 'Contribute to others',
  },
  {
    value: 4,
    label: 'Connect',
  },
  {
    value: 5,
    label: 'Collaborate',
  },
]

export const leadershipSkillArray = [
  {
    value: 1,
    label: 'Self-Awareness',
  },
  {
    value: 2,
    label: 'Timely Decision Making',
  },
  {
    value: 3,
    label: 'Learning on the Fly',
  },
  {
    value: 4,
    label: 'Strategic Agility',
  },
  {
    value: 5,
    label: 'Decision Quality',
  },
  {
    value: 6,
    label: 'Goal & Priority Setting',
  },
  {
    value: 7,
    label: 'Action Oriented',
  },
  {
    value: 8,
    label: 'Work/Life Balance',
  },
  {
    value: 9,
    label: 'Measuring & Managing Goals & Priorities',
  },
  {
    value: 10,
    label: 'Drive for Results',
  },
  {
    value: 11,
    label: 'Approachability',
  },
  {
    value: 12,
    label: 'Active Listening',
  },
  {
    value: 13,
    label: 'Empathy',
  },
  {
    value: 14,
    label: 'Understanding Others',
  },
  {
    value: 15,
    label: 'Caring for Others',
  },
  {
    value: 16,
    label: 'Motivating Others',
  },
  {
    value: 17,
    label: 'Problem Solving',
  },
  {
    value: 18,
    label: 'Empowering Others',
  },
  {
    value: 19,
    label: 'Directing Others',
  },
  {
    value: 20,
    label: 'Developing Others',
  },
]
